import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'reactstrap';
import clearModal from '@shoflo/studio-redux/actions/modal/clearModal/clearModal';
import { PresenterSettings as PresenterSettingsComponent } from '@shoflo/polymer/components/PresenterSettings/PresenterSettings';
import updatePresenterSettings from 'actions/Broadcast/presenters/updatePresenterSettings';
import { CAMERA_PRESENTER } from '@studio/constants/Sources';
import { AgoraAttendeeTile } from '@shoflo/polymer/components/Tile/AgoraAttendeeTile';
import { AttendeeTile } from '@shoflo/polymer/components/Tile/AttendeeTile';
import { GENERIC_PRESENTER_SETTINGS } from '@studio/constants/ModalTypes';
import { VENDOR_AGORA } from '@studio/constants/Vendor';

const PresenterSettings = () => {
  const modal = useSelector(state => state.modal);
  const presenterSettingsSource = useSelector(
    state => state.presenterSettingsSource
  );
  const attendeeTiles = useSelector(
    state => state.meeting?.attendeeTiles ?? []
  );

  const isOpen = modal && modal.type === GENERIC_PRESENTER_SETTINGS;
  const vendor = modal?.initialValue?.vendor;

  const dispatch = useDispatch();

  const clearThisModal = () => dispatch(clearModal(GENERIC_PRESENTER_SETTINGS));

  const handleFormSave = payload => {
    dispatch(updatePresenterSettings(presenterSettingsSource, payload));
    clearThisModal();
  };

  const AttendeeTileComponent =
    vendor === VENDOR_AGORA ? AgoraAttendeeTile : AttendeeTile;

  const maxWidthMap = {
    [CAMERA_PRESENTER]: '436px',
    default: '572px'
  };

  const style = {
    maxWidth: maxWidthMap[presenterSettingsSource.type] || maxWidthMap.default
  };

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} toggle={clearThisModal} autoFocus style={style}>
      <PresenterSettingsComponent
        source={presenterSettingsSource}
        attendeeTiles={attendeeTiles}
        onSubmit={handleFormSave}
        onCancel={clearThisModal}
        AttendeeTileComponent={AttendeeTileComponent}
      />
    </Modal>
  );
};

export default PresenterSettings;
